<template>
  <div>
  </div>
</template>
<script>
import idleTimeout from 'idle-timeout'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      instanceIdle: null,
      idleTime: 30000,
      prolongTime: false
    }
  },
  computed: {
    ...mapState(['ajaxCounter'])
  },
  props: {
    compFrom: {
      type: String,
      required: false,
      default: 'TotemHome'
    }
  },
  watch: {
    ajaxCounter (newValue, oldValue) {
      if (newValue > 0) {
        this.destroyIdle()
      } else if (newValue === 0) {
        this.setIdle()
      }
    }
  },
  mounted: function () {
    this.setIdle()
  },
  beforeDestroy: function () {
    this.destroyIdle()
  },
  methods: {
    destroyIdle: function () {
      if (this.instanceIdle !== null) this.instanceIdle.destroy()
    },
    setIdle: function () {
      this.destroyIdle()
      this.instanceIdle = idleTimeout(
        () => {
          this.redirectToIdle()
        },
        {
          element: document,
          timeout: this.idleTime,
          loop: false
        }
      )
    },
    redirectToIdle: function () {
      var vm = this
      this.$router.push({
        name: 'IdleScreen',
        params: { from: vm.compFrom }
      })
    }
  }
}
</script>
